import loginState from 'root/common/util/getLoginState';
import env from 'root/common/util/env';
import { compareVersion } from 'root/common/util/getAppVersion';
import url from 'root/common/util/url';
import { getMessageByAliMiniWebView } from './aliMiniBridge';

// 获取微信小程序特有参数
export function getMiniEnv() {
    try {
        const miniEnvJson = window.localStorage.getItem('miniEnv');
        if (miniEnvJson) return JSON.parse(miniEnvJson);
        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
}

// 获取特定值
export function getMiniEnvOfKey(key) {
    const miniEnv = getMiniEnv();
    return (miniEnv && miniEnv[key]) || '';
}

// 获取小程序webview是否游客模式
export function isMiniVisitor() {
    return env.isWechatMini && !loginState();
}
/**
 * 判断是否在某个小程序内嵌页面
 * @param {string} appId
 */
export function isSomeMini(appId) {
    return env.isWechatMini && getMiniEnvOfKey('appId') === appId;
}

/**
 * 是否可跳原生小程序详情页面
 * 骑士卡主小程序已支持
 * 拼团暂不支持
 */
export function canNavigateToNativeDetail() {
    const version = getMiniEnvOfKey('version');
    // 骑士卡主小程序，且版本大于等于1.1.0
    const main = env.isMainMiniProgram && compareVersion(version, '1.1.0') !== -1;
    // 拼团小程序
    const team = false;
    return main || team;
}

/**
 * 支付宝内嵌H5跳转到支付宝小程序
 */
export function gotoAliMiniProgram({ appId, path, query }) {
    const queryStr = url.queryToString(query);
    const scheme = `alipays://platformapi/startapp?appId=${appId}&page=${path}?${queryStr}`;
    window.location.href = scheme;
}

/**
 * 获取支付宝userId
 */
export async function getAliUserId() {
    const res = await getMessageByAliMiniWebView('getAliUserId');
    return new Promise(resolve => {
        resolve(res.aliUserId);
    });
}

// 拼团小程序
export const isPintuanMini = isSomeMini('wx315a4e0da373a2f5');

// 社群小程序相关appid
export const GROUP_APPID = [
    // 校园生活钜惠小程序
    'wxf4231f35bfc2032c',
];

// 社群小程序
export const isGroupMiniProgram = GROUP_APPID.some(appid => isSomeMini(appid));
// 职业便利小程序
export const JobConvenienceAliMiniAppId = '2019100868250007';
export const isJobConvenienceAliMini = env.isAliPayMini && getMiniEnvOfKey('appId') === JobConvenienceAliMiniAppId;

// 支付宝小程序appid集
export const aliMiniAppIdList = [
    '2019100868250007', // 职业福利
    '2021003139644815', // 骑士优选
];

// 判断能否使用postmessage方式获取信息
export const canUsePostMessage = () => {
    const appId = getMiniEnvOfKey('appId');
    if (env.isAliPayMini && appId) {
        return aliMiniAppIdList.includes(appId);
    }
    return false;
};

// 获取当前小程序id
export const getAlipayMiniAppId = () => {
    if (env.isAliPayMini) {
        return getMiniEnvOfKey('appId') || '2021003139644815'; //  '2021003139644815' 骑士优选小程序
    }
    return null;
};

// 获取当前小程序source
export const getAlipayMiniSource = appId => {
    const currentAppId = appId || getAlipayMiniAppId();
    const sourceMap = {
        [JobConvenienceAliMiniAppId]: 'aliCareer',
    };
    if (env.isAliPayMini) {
        return sourceMap[currentAppId] || 'qiShiYx'; //'qiShiYx' 骑士优选小程序
    }
    return null;
};
